// Returns a value to the fixed number of decimals required, and removes any trailing zeros.

export const dp = (value: number, decimals = 2) =>
  parseFloat(value.toFixed(decimals));
